import { useEffect, useState } from "react";
import { PageHead } from "../GtaxShell";

const STEPS = [
  ["Android", "android", ["Open gta-x.io in Chrome.", "Tap \"Install the app\" above, or tap ⋮ (top right) and choose \"Install app\".", "The GTA X icon appears on your home screen."]],
  ["iPhone and iPad", "ios", ["Open gta-x.io in Safari.", "Tap the Share button (square with an arrow).", "Choose \"Add to Home Screen\", then \"Add\"."]],
  ["Mac", "mac", ["Safari: open gta-x.io, then File → \"Add to Dock\".", "Chrome or Edge: tap \"Install the app\" above, or click the install icon at the right of the address bar.", "GTA X opens in its own window from the Dock or Launchpad."]],
];

export default function GtaxInstall() {
  const [prompt, setPrompt] = useState(() => window.__installPrompt || null);
  const [done, setDone] = useState(window.matchMedia?.("(display-mode: standalone)").matches);
  useEffect(() => {
    const on = () => setPrompt(window.__installPrompt);
    window.addEventListener("gtax-installable", on);
    return () => window.removeEventListener("gtax-installable", on);
  }, []);
  const install = async () => {
    prompt.prompt();
    const r = await prompt.userChoice;
    if (r.outcome === "accepted") { setDone(true); window.__installPrompt = null; setPrompt(null); }
  };
  return (
    <div data-testid="gtax-install-page">
      <PageHead eyebrow="The GTA X app" title="GTA X on your phone and computer."
        sub="Install the GTA X app on Android, iPhone, iPad or Mac. It opens full screen with its own icon, and always shows the latest version." />
      <section className="pb-24">
        <div className="gx-wrap space-y-10">
          {done ? <p className="gx-serif text-2xl" data-testid="gtax-install-done">The app is installed on this device.</p>
            : prompt && <button onClick={install} className="gx-btn" data-testid="gtax-install-button">Install the app</button>}
          <div className="grid md:grid-cols-3 gap-6">
            {STEPS.map(([h, id, s]) => (
              <div key={id} className="gx-card p-8" data-testid={`gtax-install-${id}`}>
                <h2 className="gx-caps text-xl">{h}</h2>
                <ol className="mt-4 space-y-3 text-[color:var(--mute)] leading-relaxed list-decimal pl-5">{s.map((x) => <li key={x}>{x}</li>)}</ol>
              </div>
            ))}
          </div>
          <p className="text-sm text-[color:var(--mute)]">The app uses the same secure site as gta-x.io: your membership, status and statements stay exactly as they are.</p>
        </div>
      </section>
    </div>
  );
}
